export default __webpack_public_path__ + "static/assets/d8cd1510c7fc1fe1859912ddb8a7042e.png";